module.exports = __webpack_public_path__ + "img/dice-5.db51bc85.svg";